module.exports = __webpack_public_path__ + "img/tu08.842ef2a9.jpg";